module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotRegistrations) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    style: (_vm.playerColumnWidth)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails) ? _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.comment')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.registered')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.confirmed')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails && !_vm.hasMissionEnded) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotRegistrations), function(registration) {
    return _c('mission-slot-registrations-row', {
      key: registration.uid,
      attrs: {
        "registration": registration
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotRegistrations.length >= 10),
      expression: "missionSlotRegistrations.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    style: (_vm.playerColumnWidth)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails) ? _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.comment')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.registered')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.confirmed')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails && !_vm.hasMissionEnded) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))]) : _vm._e()])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d5eb3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotRegistrationsTable.vue
// module id = 513
// module chunks = 0